<app-prodgroup-search [(display)]="displayGS" [groupId]="selectedGroupId" (selectedGroup)="onSelectedGroup($event)" closeOnSelection="true"></app-prodgroup-search>
<div *ngIf="selectedPg as sPg else loading">
  <div class="field">
    <label for="pgname" class="do-not-wrap-text">{{labelKey}} ({{prodGroupId}})</label>
    <div class="p-inputgroup">
      <input id="pgname" type="text" pInputText [value]="sPg.PGROUPNAME" placeholder="Группа товаров" [disabled]="disabled">
      <button type="button" pButton icon="pi pi-sitemap" class="p-button-warn mr-1" (click)="onProductGroupButton($event)"
              pTooltip="Выбрать группу для товара" tooltipPosition="top" [disabled]="disabled"></button>
      <button type="button" pButton icon="pi pi-window-maximize" class="p-button-help" (click)="onOpenProductGroup($event)"
              pTooltip="Открыть всю группу товаров" tooltipPosition="top" [disabled]="disabled"></button>
    </div>
  </div>
</div>
<ng-template #loading>
  <p>Информация загружается...</p>
</ng-template>
